import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { routes } from '@/routes/config'

import { useDiagnosisViewPage } from './hooks/use-diagnosis-view-page'
import { useStyles } from './styles'

const DiagnosisView = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const { isValid, CurrentComponent } = useDiagnosisViewPage()

  useEffect(() => {
    if (isValid) return

    navigate(routes.Diagnoses())
  }, [isValid])

  return (
    <div className={classes.root}>
      {isValid && CurrentComponent && <CurrentComponent />}
    </div>
  )
}
export default DiagnosisView
